import { values, TranslationLanguages, TranslationKeys } from './values'
import get from 'lodash/get'

export class Translations {

  language: TranslationLanguages

  constructor(language: TranslationLanguages) {
    this.language = language
  }

  get(key: TranslationKeys): string {
    const found = values.find(item => item.key === key)
    if (found) {
      const translation = get(found.translations, this.language)
      if (translation) {
        return translation
      }
    }
    return 'translation-not-found'
  }

}